var React = require('react');

function IconReturnKey (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeWidth":"1","fill":"currentColor","fillRule":"evenodd"},React.createElement("path",{"d":"M15,8.23921879 L3.52878851,8.23921879 L5.65850461,10.1772839 C6.07414124,10.5555178 6.11625875,11.2125589 5.75257669,11.6448262 C5.38889464,12.0770936 4.75713202,12.1208963 4.34149539,11.7426624 L0.341495392,8.10261831 C-0.113831797,7.68826555 -0.113831797,6.95159259 0.341495392,6.53723983 L4.34149539,2.89719574 C4.75713202,2.51896183 5.38889464,2.56276456 5.75257669,2.9950319 C6.11625875,3.42729923 6.07414124,4.08434031 5.65850461,4.46257422 L3.71248211,6.23347614 L14,6.23347614 L14,1.00287132 C14,0.449000786 14.4477153,0 15,0 C15.5522847,0 16,0.449000786 16,1.00287132 L16,7.23634747 C16,7.79021801 15.5522847,8.23921879 15,8.23921879 Z","id":"Combined-Shape"})));
}

IconReturnKey.defaultProps = {"viewBox":"0 0 16 12"};

module.exports = IconReturnKey;

IconReturnKey.default = IconReturnKey;
